
<template>
  <div @click="toggleField" @mouseup="checkSelection">
    <!-- <contentPage @playVideo="playVideo"></contentPage> -->
    <contentIndex ref="contentIndex" :bookContent="bookContent"></contentIndex>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      style="z-index: 10000"
    >
      <video
        :src="video_src"
        width="100%"
        controls
        autoplay
        muted
        webkit-playsinline="true"
        playsinline="true"
        controlsList="nodownload"
      ></video>
    </el-dialog>
    <el-dialog
      :title="mp3Title"
      :visible.sync="mp3Show"
      :destroy-on-close="true"
      style="z-index: 10000"
    >
      <div class="audio_box">
        <audio :src="audio_src" controls></audio>
      </div>
    </el-dialog>
    <slot name="bubble"></slot>
  </div>
</template>

  <script>
import contentPage from "./contentPage"; //页面内容
import contentIndex from "../../../content/index"; //页面内容
import tables from "./tables"; //table组件
import Extend from "./Extend"; //拓展内容组件
export default {
  name: "BookContent",
  components: {
    tables,
    Extend,
    contentPage,
    contentIndex
  },
  props: {
    bookContent: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      mp3Show: false,
      mp3Title: "",
      bubbleShow1: false,
      bubbleShow2: false,
      bubbleShow3: false,
      dialogVisible: false, // 弹出对话框
      dialogTitle: "", // 对话框的title
      // audio_src: require("../assets/audio/audio.mp3"),
      audio_src: '',
      srcList: [
        require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"),
        require("@/assets/images/bookContent/图1-2  数据相关术语.png"),
        require("@/assets/images/bookContent/图1-3  自然语言处理.png"),
        require("@/assets/images/bookContent/图1-4  自动驾驶汽车.jpeg"),
        require("@/assets/images/bookContent/图1-5  回归任务.png"),
        require("@/assets/images/bookContent/图1-6  分类任务.png"),
        require("@/assets/images/bookContent/图1-7  聚类任务.png"),
        require("@/assets/images/bookContent/图1-8  机器学习的一般过程.png"),
        require("@/assets/images/bookContent/图1-9  手写数字“1”及其对应二维矩阵.png"),
        require("@/assets/images/bookContent/图1-10  过拟合与欠拟合的直观类比.png"),
        require("@/assets/images/bookContent/图1-11  使用模型预测新样本.png"),
        require("@/assets/images/bookContent/图1-12  使用Matplotlib绘制的图形.png"),
      ],
      videoList: [
        // require("../assets/video/1-1人工智能、机器学习与深度学习的关系.mp4"),
        // require("../assets/video/1-2机器学习的发展历史.mp4"),
        // require("../assets/video/1-3世上无难机器学习入门.mp4"),
        // require("../assets/video/1-4机器学习的类型扩展.mp4"),
        // require("../assets/video/1-5标准差的计算方法.mp4"),
        // require("../assets/video/1-6安装Anaconda.mp4"),
        // require("../assets/video/1-7使用Jupyter Notebook.mp4"),
      ],
      video_src: "", // 当前播放的视频链接

      table_01: {
        assessConfig: [
          { label: "序 号", prop: "number" },
          { label: "长度/（cm）", prop: "length" },
          { label: "质量/（g）", prop: "quality" },
          { label: "材  质", prop: "science" },
          { label: "类  别", prop: "category" },
        ],
        assessTableData: [
          {
            number: "1",
            length: "25",
            quality: "8",
            science: "竹",
            category: "筷子",
          },
          {
            number: "2",
            length: "23",
            quality: "7",
            science: "竹",
            category: "筷子",
          },
          {
            number: "3",
            length: "20",
            quality: "4",
            science: "木",
            category: "筷子",
          },
          {
            number: "4",
            length: "6",
            quality: "0.1",
            science: "竹",
            category: "牙签",
          },
          {
            number: "5",
            length: "5",
            quality: "0.08",
            science: "竹",
            category: "牙签",
          },
          {
            number: "6",
            length: "5.8",
            quality: "0.09",
            science: "竹",
            category: "牙签",
          },
          {
            number: "...",
            length: "...",
            quality: "...",
            science: "...",
            category: "...",
          },
        ],
      },
      table_02: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "姓  名", prop: "name" },
          { label: "年龄/（岁）", prop: "age" },
          { label: "年收入/（元）", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费/（元）", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 1,
            name: "张三",
            age: 36,
            income: 50000,
            sex: "男",
            education: "本科",
            consumption: "30000",
          },
          {
            number: 2,
            name: "赵琦",
            age: 42,
            income: 45000,
            sex: "女",
            education: "本科",
            consumption: "40000",
          },
          {
            number: 3,
            name: "李武",
            age: 23,
            income: 30000,
            sex: "男",
            education: "高中",
            consumption: "",
          },
          {
            number: 4,
            name: "王波",
            age: 61,
            income: 70000,
            sex: "男",
            education: "本科",
            consumption: "20000",
          },
        ],
      },
      table_03: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "姓  名", prop: "name" },
          { label: "年龄/（岁）", prop: "age" },
          { label: "年收入/（元）", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费/（元）", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 5,
            name: "刘玉琦",
            age: 38,
            income: 20000,
            sex: "女",
            education: "大专",
            consumption: "10000",
          },
          {
            number: 6,
            name: "赵琦",
            age: 42,
            income: 45000,
            sex: "女",
            education: "本科",
            consumption: "40000",
          },
          {
            number: 7,
            name: "赵倩",
            age: -5,
            income: 30000,
            sex: "女",
            education: "本科",
            consumption: "90000",
          },
        ],
      },
      table_04: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "年龄/（岁）", prop: "age" },
          { label: "年收入/（元）", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费/（元）", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 1,
            age: 36,
            income: 50000,
            sex: "男",
            education: "本科",
            consumption: "30000",
          },
          {
            number: 2,
            age: 42,
            income: 45000,
            sex: "女",
            education: "本科",
            consumption: "40000",
          },
          {
            number: 3,
            age: 23,
            income: 30000,
            sex: "男",
            education: "高中",
            consumption: "",
          },
          {
            number: 4,
            age: 61,
            income: 70000,
            sex: "男",
            education: "本科",
            consumption: "20000",
          },
          {
            number: 5,
            age: 38,
            income: 20000,
            sex: "女",
            education: "大专",
            consumption: "10000",
          },
          {
            number: 6,
            age: 42,
            income: 45000,
            sex: "女",
            education: "本科",
            consumption: "40000",
          },
          {
            number: 7,
            age: -5,
            income: 30000,
            sex: "女",
            education: "本科",
            consumption: "90000",
          },
        ],
      },
      table_05: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "年龄/（岁）", prop: "age" },
          { label: "年收入/（元）", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费/（元）", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 1,
            age: 36,
            income: 50000,
            sex: "男",
            education: "本科",
            consumption: "30000",
          },
          {
            number: 2,
            age: 42,
            income: 45000,
            sex: "女",
            education: "本科",
            consumption: "40000",
          },
          {
            number: 3,
            age: 23,
            income: 30000,
            sex: "男",
            education: "高中",
            consumption: "15000",
          },
          {
            number: 4,
            age: 61,
            income: 70000,
            sex: "男",
            education: "本科",
            consumption: "20000",
          },
          {
            number: 5,
            age: 38,
            income: 20000,
            sex: "女",
            education: "大专",
            consumption: "10000",
          },
        ],
      },
      table_06: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "年龄/（岁）", prop: "age" },
          { label: "年收入/（元）", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费/（元）", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 1,
            age: 36,
            income: 50000,
            sex: "1",
            education: "60",
            consumption: "30000",
          },
          {
            number: 2,
            age: 42,
            income: 45000,
            sex: "2",
            education: "60",
            consumption: "40000",
          },
          {
            number: 3,
            age: 23,
            income: 30000,
            sex: "1",
            education: "20",
            consumption: "15000",
          },
          {
            number: 4,
            age: 61,
            income: 70000,
            sex: "1",
            education: "60",
            consumption: "20000",
          },
          {
            number: 5,
            age: 38,
            income: 20000,
            sex: "2",
            education: "40",
            consumption: "10000",
          },
        ],
      },
      table_07: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "年  龄", prop: "age" },
          { label: "年收入", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 1,
            age: 0.34,
            income: 0.6,
            sex: "0",
            education: "1",
            consumption: "0.67",
          },
          {
            number: 2,
            age: 0.5,
            income: 0.5,
            sex: "1",
            education: "1",
            consumption: "1",
          },
          {
            number: 3,
            age: 0,
            income: 0.2,
            sex: "0",
            education: "0",
            consumption: "0.17",
          },
          {
            number: 4,
            age: 1,
            income: 1,
            sex: "0",
            education: "1",
            consumption: "0.33",
          },
          {
            number: 5,
            age: 0.39,
            income: 0,
            sex: "1",
            education: "0.5",
            consumption: "0",
          },
        ],
      },
      table_08: {
        assessConfig: [
          { label: "序  号", prop: "number" },
          { label: "年  龄", prop: "age" },
          { label: "年收入", prop: "income" },
          { label: "性  别", prop: "sex" },
          { label: "学  历", prop: "education" },
          { label: "年消费", prop: "consumption" },
        ],
        assessTableData: [
          {
            number: 1,
            age: -0.33,
            income: 0.41,
            sex: "-0.82",
            education: "0.75",
            consumption: "0.65",
          },
          {
            number: 2,
            age: 0.16,
            income: 0.12,
            sex: "1.22",
            education: "0.75",
            consumption: "1.58",
          },
          {
            number: 3,
            age: -1.38,
            income: -0.76,
            sex: "-0.82",
            education: "-1.75",
            consumption: "-0.74",
          },
          {
            number: 4,
            age: 1.71,
            income: 1.56,
            sex: "-0.82",
            education: "0.75",
            consumption: "-0.28",
          },
          {
            number: 5,
            age: -0.16,
            income: -1.34,
            sex: "1.22",
            education: "-0.5",
            consumption: "-1.21",
          },
        ],
      },
      table_09: {
        assessConfig: [
          { label: "方 法 名", prop: "methods" },
          { label: "是否需要真实值监控", prop: "monitor" },
          { label: "最 佳 值", prop: "bestVal" },
        ],
        assessTableData: [
          {
            methods: "ARI（兰德系数）评价法",
            monitor: "需要",
            bestVal: "1.0",
          },
          {
            methods: "AMI（互信息）评价法",
            monitor: "需要",
            bestVal: "1.0",
          },
          {
            methods: "V-measure评分",
            monitor: "需要",
            bestVal: "1.0",
          },
          {
            methods: "FMI评价法",
            monitor: "需要",
            bestVal: "1.0",
          },
          {
            methods: "轮廓系数评价法",
            monitor: "不需要",
            bestVal: "畸变程度最大",
          },
          {
            methods: "calinski_harabasz指数评价法",
            monitor: "不需要",
            bestVal: "相比较最大",
          },
        ],
      },
      table_10: {
        assessConfig: [
          { label: "蓝", prop: "blue" },
          { label: "绿", prop: "green" },
          { label: "红", prop: "red" },
          { label: "青", prop: "young" },
          { label: "品  红", prop: "Magenta" },
          { label: "黄", prop: "yellow" },
          { label: "黑", prop: "black" },
          { label: "白", prop: "white" },
        ],
        assessTableData: [
          {
            blue: "'b'",
            green: "'g'",
            red: "'r'",
            young: "'c'",
            Magenta: "'m'",
            yellow: "'y'",
            black: "'k'",
            white: "'w'",
          },
        ],
      },
      table_11: {
        assessConfig: [
          { label: "实  线", prop: "line1" },
          { label: "虚  线", prop: "line2" },
          { label: "点  线", prop: "line3" },
          { label: "星  型", prop: "line4" },
          { label: "正 方 形", prop: "line5" },
          { label: "五 边 形", prop: "line6" },
          { label: "加  号", prop: "line7" },
          { label: "正 三 角", prop: "line8" },
        ],
        assessTableData: [
          {
            line1: "'-'",
            line2: "'--'",
            line3: "':'",
            line4: "'*'",
            line5: "'s'",
            line6: "'p'",
            line7: "'+'",
            line8: "'^'",
          },
        ],
      },
      tableData: [
        {
          date: "正例",
          just: "真正例（TP）",
          back: "假反例（FN）",
        },
        {
          date: "反例",
          just: "假正例（FP）",
          back: "真反例（TN）",
        },
      ],
    };
  },
  methods: {
    bubbleClick(){
      console.log(111111)
    },
    //显示音频文件
    mp3Click() {
      this.mp3Show = true;
      // this.mp3Title='';
    },
    toggleField() {
      this.bubbleShow1 = false;
      this.bubbleShow2 = false;
      this.bubbleShow3 = false;
    },
    bullleClick() {
      this.bubbleShow1 = !this.bubbleShow1;
    },
    bullle2Click() {
      this.bubbleShow2 = !this.bubbleShow2;
    },
    bullle3Click() {
      this.bubbleShow3 = !this.bubbleShow3;
    },
    // 播放视频
    playVideo(index) {
      this.dialogVisible = true;
      this.video_src = this.videoList[index];
      this.dialogTitle = "播放视频";
    },
    checkSelection() {
      this.$emit('checkSelection')
    },
    tableTabChange(tableKey, tableTabKey) {
      this.$refs.contentIndex.tableTabChange(tableKey, tableTabKey)
    },
  },
};
</script>


<style scoped lang="scss">
@import "@/assets/styles/bookContent.scss";
/deep/.el-table thead.is-group th.el-table__cell {
  background: #00a7ab !important;
}
/deep/.el-table--border th.el-table__cell {
  border-bottom: 1px solid #44bfc2 !important;
}
.audio_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
}
</style>
